import { BaseController } from '~/utils/base-controller';

/** @type {boolean} */
const forceConfig = true;

export default class v5FrameController extends BaseController {
	/** @type {string} */
	src = '';

	/** @type {string} */
	frameClasses = '';

	/** @type {Record<string, string>} */
	params = {};

	/* @ngInject */
	// eslint-disable-next-line no-useless-constructor
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {import('angular').IRootElementService} $element
	 */
	constructor(
		$injector,
		$element,
	) {
		super($injector);

		/** @type {string} */
		this.token = this.$rootScope.context?.token.id ?? '';

		/** @type {string} */
		this.endpoint = this.$rootScope.context?.url?.back ?? '';

		/** @type {string} */
		this.v5URL = this.$rootScope.appConfig.config.V5?.url ?? '/front5';

		// @ts-ignore
		// eslint-disable-next-line no-undef
		if (process.env.NODE_ENV !== 'production' && forceConfig === true) {
			this.v5URL = 'http://localhost:5000/front5';
		}

		if (!this.v5URL.endsWith('/')) {
			this.v5URL += '/';
		}

		/** @type {HTMLElement | undefined} */
		this.iframe = $element.find('iframe').get(0);

		/** @type {?Function} */
		this.onMessage = null;

		// Références liées une seule fois : .bind() renvoie une nouvelle fonction à chaque
		// appel, donc removeEventListener ne retrouvait jamais le handler enregistré.
		// Les réutiliser rend aussi loadIframe() idempotent, car addEventListener ignore
		// un réenregistrement de la même référence (il est appelé depuis $onInit et
		// $onChanges).
		this.onLoadHandler = this.onLoad.bind(this);
		this.onErrorHandler = this.onError.bind(this);
		this.onMessageBoundHandler = this.onMessageHandler.bind(this);
	}

	$onDestroy() {
		this.iframe?.removeEventListener('load', this.onLoadHandler);
		this.iframe?.removeEventListener('error', this.onErrorHandler);
		window.removeEventListener('message', this.onMessageBoundHandler);
	}

	loadIframe() {
		if (!this.src) {
			throw new Error('src is required');
		}

		this.iframe?.addEventListener('load', this.onLoadHandler);
		this.iframe?.addEventListener('error', this.onErrorHandler);
		window.addEventListener('message', this.onMessageBoundHandler);

		this.$rootScope.waiting = true;

		const url = this.v5URL.startsWith('http')
			? new URL(`${this.v5URL}${this.src}`)
			: new URL(`${this.v5URL}${this.src}`, window.location.href);

		url.searchParams.set('token', this.token);
		url.searchParams.set('endpoint', this.endpoint);
		url.searchParams.set('from', '4');

		if (this.params) {
			for (const [key, value] of Object.entries(this.params)) {
				url.searchParams.set(key, value);
			}
		}

		this.iframeSrc = this.$sce.trustAsResourceUrl(
			url.href,
		);
	}

	// noinspection JSCheckFunctionSignatures
	$onChanges() {
		this.loadIframe();
	}

	$onInit() {
		this.loadIframe();
	}

	/**
	 * @param {any} message
	 */
	onMessageHandler(message) {
		if (message.data && message.data.event && message.data.from === 'v5') {
			const { data } = message;

			const { event } = data;

			if (event === 'changeURL') {
				const { url } = data;
				const newURL = new URL(window.location.origin + url);
				this.$timeout(() => {
					this.$location.path(newURL.pathname);
					for (const [key, value] of newURL.searchParams) {
						this.$location.search(key, value);
					}
				});
			}
			if (event === 'openURL') {
				const { url } = data;
				const newURL = new URL(window.location.origin + url);
				window.open(newURL.href, '_blank');
			}
			else if (event === 'setQuery') {
				const { key, value } = data;
				this.$timeout(() => {
					this.$location.search(key, value);
				});
			}
			else {
				if (this.onMessage) {
					this.onMessage({ $event: data })
				}
			}
		}
	}

	onLoad() {
		this.$timeout(() => {
			this.$rootScope.waiting = false;
		});
	}

	/**
	 * @param {any} error
	 */
	onError(error) {
		console.error('aaa', error);
		this.$timeout(() => {
			this.$rootScope.waiting = false;
		});
	}
}
